(function($) {
    'use strict';

    $(document).ready(function () {
        $( '.sub-menu-item' ).wrapAll( "<ul class='sub-menu' />");
    });

    $(document.body).on('click', '.toggle-sub-menu', function() {
        $(this).toggleClass('active');
        $(this).next().slideToggle();
    });

}(jQuery));
